<template>
	<div
		:id="mapId"
		class="w-full"
		:class="height"
	/>
</template>

<script setup lang="ts">
import { useMap } from '@/composables/useMap'

const props = defineProps({
	mapCenter: {
		type: Object as PropType<google.maps.LatLngLiteral>,
		default: () => {}
	},
	address: {
		type: String,
		default: ''
	},
	mapId: {
		type: String,
		required: true
	},
	showPin: {
		type: Boolean,
		default: true
	},
	draggablePin: {
		type: Boolean,
		default: true
	},
	roadMap: {
		type: Boolean,
		default: false
	},
	zoom: {
		type: Number,
		default: 20
	},
	height: {
		type: String,
		default: 'h-96'
	},
	showZoomControl: {
		type: Boolean,
		default: false
	}
})
const {
	mapCenter, address, mapId, showPin, draggablePin, roadMap, zoom, showZoomControl
} = toRefs(props)
const { pinCoords } = await useMap({ mapCenter: mapCenter.value,
	address: address.value,
	elementId: mapId.value,
	pin: showPin.value,
	draggable: draggablePin.value,
	roadMap: roadMap.value,
	zoom: zoom.value,
	showZoomControl: showZoomControl.value })

const emit = defineEmits([ 'update:modelValue' ])

watch(pinCoords, newVal => {
	emit('update:modelValue', newVal)
}, { immediate: true })
</script>
